import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DistributionsTable from "../../../components/distributionsTable/DistributionsTable";
import { Box, Toolbar, Typography } from "@mui/material";
import "./styles.scss";
import DistributionDetails from "../../../components/distributionDetails/DistributionDetails";
import { PartnershipType } from "../../../types/genericType";
import { getAllPartnerships, getPartnerShipDistributions } from "../../../services/partnershipService";
import { setPartnerships, setDistributions } from "../../../redux/features/partnershipsSlice";

const Distributions = () => {
  const { partnershipsData } = useSelector((state: any) => state.partnershipsState);
  const [selectedPartnership, setSelectedPartnership] =
    useState<PartnershipType | null>(null);
  const dispatch = useDispatch();

  const setPartnershipsData = (partnershipsData: PartnershipType[]) => {
    dispatch(setPartnerships(partnershipsData));
  };

  useEffect(() => {
    if (partnershipsData.length === 0) {
      getAllPartnerships()
        .then((res) => {
          setPartnershipsData(res);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [partnershipsData]);

  const handlePartenershipSelection = (partnership: PartnershipType) => {
    if (partnership && partnership.id) {
      setSelectedPartnership(partnership);
      getPartnerShipDistributions(partnership.id).then((res) => {
        dispatch(setDistributions(res));
      }).catch((err) => {
        console.log(err);
      });
    }
  };


  return (
    <>
      <Toolbar className="toolbar">
        <Typography className="title">Partnership Distributions</Typography>
      </Toolbar>
      <Box style={{ display: "flex", justifyContent: "flex-start" }}>
        <DistributionsTable
          data={partnershipsData.filter((partnership: PartnershipType) => partnership.isActive)}
          setSelectedPartnership={handlePartenershipSelection}
        />
        {selectedPartnership && (
          <DistributionDetails selectedPartnership={selectedPartnership} />
        )}
      </Box>
    </>
  );
};

export default Distributions;
